<template>
  <div>
    <!-- Activador tipo combo -->
    <v-menu
      v-model="menu"
      offset-y
      :close-on-content-click="false"
      :retain-focus="false"
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
            v-bind="attrs" v-on="on"
            :value="displayLabel"
            label="Semanas"
            readonly
            dense
            hide-details
            clearable
            append-icon="mdi-menu-down"
            class="weekpicker-input"
            @click:clear="clearAll"
        />
      </template>

      <!-- CONTENIDO: calendario por semanas -->
      <v-card class="pa-2" tile max-width="600px" :ripple="false">
        <v-row align="center" no-gutters class="px-2">
          <v-btn icon small @click="prevMonth"><v-icon>mdi-chevron-left</v-icon></v-btn>
          <div class="text-subtitle-2 font-weigh month-title" style="min-width: 140px;">
            {{ monthLabel }}
          </div>
          <v-spacer />
          <v-select
            dense outlined hide-details class="mr-2" style="max-width: 100px;"
            :items="years"
            v-model="currentYear"
            label="Año"
          />
          <v-btn icon small @click="nextMonth"><v-icon>mdi-chevron-right</v-icon></v-btn>
        </v-row>

        <div class="mt-1">
          <div class="d-flex px-2 py-1 grey--text text--darken-2 caption">
            <div class="week-col pr-1 text-center" style="width: 50px;">Sem</div>
            <div v-for="d in weekDays" :key="d" class="text-center flex-grow-1 week-day">{{ d }}</div>
          </div>
          <v-divider class="mb-1"></v-divider>

          <div v-for="w in weeks" :key="w.key"
                class="d-flex align-center rounded-lg mx-1 my-1 week-row"
                :class="{
                'week-selected': isSelected(w),
                'week-hover': hoverKey === w.key,
                'week-disabled': isWeekDisabled(w)
                }"
                @mouseenter="hoverKey = w.key"
                @mouseleave="hoverKey = null"
                @click="toggleWeek(w)">

            <div class="pl-1 pr-1 d-flex align-center week-col">
                <v-checkbox
                :input-value="isSelected(w)"
                :disabled="isWeekDisabled(w)"
                @click.stop="toggleWeek(w)"
                @change.stop="() => {}"
                hide-details dense class="ma-0 pa-0"
                />
                <span class="caption ml-n2">{{ w.isoWeek }}</span>
            </div>

            <!-- días -->
            <div v-for="d in w.days" :key="d.key"
                class="text-center py-2 flex-grow-1"
                :class="{ 'muted': d.month !== currentMonth, 'disabled-text': isWeekDisabled(w) }"
                style="width: calc((100% - 60px) / 7);">
                <div class="body-2">{{ d.day }}</div>
            </div>
          </div>
        </div>

        <v-divider class="my-2"></v-divider>

        <div class="px-2 d-flex align-center">
          <!--<div class="caption mr-2" v-if="!model.length">Sin semanas seleccionadas</div>
          <v-chip v-for="(sel, i) in model" :key="sel.start + '_' + sel.end" class="ma-1" label x-small close @click:close="removeAt(i)">
            W{{ sel.isoWeek }} • {{ formatRange(sel.start, sel.end) }}
          </v-chip>-->
          <v-spacer></v-spacer>
          <v-btn small text color="red" @click="clearAll">Limpiar</v-btn>
          <v-btn small color="primary" depressed class="ma-1" @click="apply">Aplicar</v-btn>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'WeekPickerCalendar',
  props: {
    value: { type: Array, default: () => [] },
    month: { type: Number, default: null },
    year: { type: Number, default: null },
    years: { type: Array, default: () => {
      const y = new Date().getFullYear();
      const arr = []; for (let i = y - 3; i <= y + 3; i++) arr.push(i); return arr;
    }},
  },
  data() {
    const today = new Date();
    return {
      currentMonth: this.month || (today.getMonth() + 1),
      currentYear: this.year || today.getFullYear(),
      hoverKey: null,
      model: [...(this.value || [])],
      menu: false,
      today
    };
  },
  computed: {
    monthLabel() { const m = this.currentMonth - 1; const dt = new Date(this.currentYear, m, 1); return dt.toLocaleDateString('es-MX', { month: 'short', year: 'numeric' }); },
    weekDays() { return ['lu', 'ma', 'mi', 'ju', 'vi', 'sá', 'do']; },
    displayLabel() {
      const n = this.model.length;
      if (!n) return '';
      if (n === 1) {
        const s = this.model[0];
        return `Semana ${s.isoWeek}`;
      }
      return `${n} semanas seleccionadas`;
    },
    weeks() {
      const m = this.currentMonth - 1;
      const monthStart = new Date(this.currentYear, m, 1);
      const monthEnd = new Date(this.currentYear, m + 1, 0);
      const gridStart = this.startOfISOWeek(monthStart);
      const gridEnd = this.endOfISOWeek(monthEnd);
      const out = [];
      let cur = new Date(gridStart);
      while (cur <= gridEnd) {
        const start = new Date(cur);
        const end = this.addDays(start, 6);
        const days = [];
        for (let i = 0; i < 7; i++) {
          const d = this.addDays(start, i);
          days.push({ key: this.fmt(d), date: d, day: d.getDate(), month: d.getMonth() + 1 });
        }
        const isoWeek = this.getISOWeek(start);
        const isoYear = this.getISOWeekYear(start);
        out.push({ key: this.fmt(start) + '_' + this.fmt(end), start, end, days, isoWeek, isoYear });
        cur = this.addDays(cur, 7);
      }
      return out;
    },
  },
  watch: { value(v) { this.model = [...(v || [])]; }, },
  methods: {
    addDays(d, n) { const x = new Date(d); x.setDate(x.getDate() + n); return x; },
    fmt(d) { const y = d.getFullYear(); const m = (d.getMonth() + 1).toString().padStart(2, '0'); const day = d.getDate().toString().padStart(2, '0'); return `${y}-${m}-${day}`; },
    startOfISOWeek(d) { const x = new Date(d); const day = (x.getDay() + 6) % 7; x.setDate(x.getDate() - day); x.setHours(0,0,0,0); return x; },
    endOfISOWeek(d) { const s = this.startOfISOWeek(d); return this.addDays(s, 6); },
    getISOWeek(date) { const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())); const dayNum = d.getUTCDay() || 7; d.setUTCDate(d.getUTCDate() + 4 - dayNum); const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1)); return Math.ceil((((d - yearStart) / 86400000) + 1) / 7); },
    getISOWeekYear(date) { const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())); const dayNum = d.getUTCDay() || 7; d.setUTCDate(d.getUTCDate() + 4 - dayNum); return d.getUTCFullYear(); },

    nextMonth() { if (this.currentMonth === 12) { this.currentMonth = 1; this.currentYear++; } else this.currentMonth++; },
    prevMonth() { if (this.currentMonth === 1) { this.currentMonth = 12; this.currentYear--; } else this.currentMonth--; },
    isSelected(w) { return this.model.some(s => s.start === this.fmt(w.start) && s.end === this.fmt(w.end)); },
    toggleWeek(w) { if (this.isWeekDisabled(w)) return; const start = this.fmt(w.start); const end = this.fmt(w.end); const idx = this.model.findIndex(s => s.start === start && s.end === end); if (idx >= 0) this.model.splice(idx, 1); else this.model.push({ start, end, isoWeek: w.isoWeek, isoYear: w.isoYear }); this.$emit('input', this.model); this.$emit('change', this.model); },
    removeAt(i) { this.model.splice(i, 1); this.$emit('input', this.model); },
    clearAll() { this.model = []; this.$emit('input', this.model); },
    apply() { this.$emit('apply', this.model); this.menu = false; },
    lastCompleteSunday() {const mondayThisWeek = this.startOfISOWeek(this.today); return this.addDays(mondayThisWeek, -1);},
    isWeekDisabled(w) {return w.end > this.lastCompleteSunday();},
    formatRange(s, e) { const p = (str) => { const [y,m,d] = str.split('-').map(Number); const dt = new Date(y, m-1, d); return dt.toLocaleDateString('es-MX', { day: '2-digit', month: 'short' }); }; return `${p(s)} — ${p(e)}`; },
  },
};
</script>

<style scoped>
.week-row { cursor: pointer; border: 1px solid transparent; }
.week-row.week-hover { background: rgba(0,0,0,0.03); }
.week-row.week-selected { background: rgba(33,150,243,0.10); border-color: rgba(33,150,243,0.35); }
.week-col { min-width: 60px; width: 60px; }
.muted { color: rgba(0,0,0,0.45); }
.weekpicker-input { max-width: 100%; font-size: 13px; }
.month-title { text-transform: capitalize; }
.week-day { width: calc((100% - 60px) / 7);}
.week-row.week-disabled { opacity: .5; cursor: not-allowed; }
.week-row.week-disabled:hover { background: transparent; }
.disabled-text { pointer-events: none; }
</style>